import generateTypes from '../../utils/generateTypes';

export const GET_APP_VERSIONS = generateTypes('GET_APP_VERSIONS');
export const RESET_APP_VERSIONS = generateTypes('RESET_APP_VERSIONS');
